import Button from "../buttons/Button";
import EmptyResults from "./EmptyResults";

type ErrorResultsProps = {
  header?: string;
  description?: string;
  alt?: string;
  image?: string;
};

const ErrorResults = (props: ErrorResultsProps) => {
  const {
    header = "Error loading results",
    description = "Try refreshing this page or reaching out to our team for help",
    alt = "No Results",
    image,
  } = props;

  return (
    <EmptyResults>
      <EmptyResults.Image src={image} alt={alt} />
      <EmptyResults.Content>
        <EmptyResults.Header>{header}</EmptyResults.Header>
        <EmptyResults.Text>{description}</EmptyResults.Text>
      </EmptyResults.Content>
      <EmptyResults.Body>
        <Button onClick={() => window.location.reload()}>Reload Page</Button>
      </EmptyResults.Body>
    </EmptyResults>
  );
};

export default ErrorResults;
